import { QuickSearchResult } from './QuickSearchResult';

export class QuickSearchResultWrapper {
  orders: QuickSearchResult[] = [];
  shipments: QuickSearchResult[] = [];

  constructor(opts?: Partial<QuickSearchResultWrapper>) {
    if (opts?.orders != null) {
      this.orders = opts.orders.map((val) => new QuickSearchResult(val));
    }
    if (opts?.shipments != null) {
      this.shipments = opts.shipments.map((val) => new QuickSearchResult(val));
    }
  }
}
